const messages = {
  message: {
    name: 'Nombre',
    surName: 'Apellidos',
    mobile: 'Movil',
    email: 'Email',
    company: 'Razón Social',
    cif: 'CIF / NIF',
    profile: 'Perfil de empresa',
    phone: 'Teléfono',
    country: 'País',
    location: 'Provincia',
    address: 'Dirección',
    city: 'Ciudad',
    cp: 'Código Postal',
    web: 'Sitio Web',
    comment: '¿Por qué se registra en este formulario?',
    terms: {
      wp:
        'He leido y acepto la <a href="/politica-privacidad">política de privacidad</a> y las <a href="http://myzone.airzone.es/condiciones-uso">condiciones de uso</a>.',
      myzone:
        'He leido y acepto la <a href="/politica-privacidad">política de privacidad</a> y las <a href="/condiciones-uso">condiciones de uso</a>.',
    },
    infoComercial: 'Quiero recibir información comercial de Airzone.',
    formsError: {
      terms: 'Debes aceptar los términos y condiciones de uso.',
      front: 'No se ha podido realizar el envío del formulario debido a los siguientes errores.',
      server: 'No se ha podido realizar el envío del por favor inténtalo más tarde.',
    },
    formsSuccess: {
      AirzoneSIM: 'Se ha registrado correctamente en breves recibirá un email con la herramienta.',
      Myzone: 'Tu solicitud ha sido registrada, sera procesada lo antes posible.',
    },
    personalData: 'Tus datos personales',
    companyData: 'Los datos sobre tu empresa',
    submit: 'Enviar',
    selectSim: {
      label: '¿Como conoció Airzone SIM?',
      options: {
        'Técnico/Comercial/Prescriptor': 'Técnico / Comercial / Prescriptor',
        'Distribuidor/Oficial/ATD': 'Distribuidor / Oficial / ATD',
        'Promotora/Constructora': 'Promotora / Constructora',
        'Arquitecto/Ingeniería': 'Arquitecto / Ingeniería',
        Instalador: 'Instalador',
        'RRSS/Medios': 'Redes sociales / Medios',
        'Cursos-Formacion': 'Cursos de Formación',
      },
    },
  },
};

export default messages;
